import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../../shared/services';
import { InspectionPlugin } from '../../../shared/models/index';
import { flatMap, map } from 'rxjs/operators';
import { InstallationReceivedPluginFactoryService } from './received-plugin-factory.plugin';

@Injectable()
export class InstallationReceivedPluginService extends InspectionPluginService {
  public documentTypeKeys: any = [];
  public statusKeys: any = [
    { value: 1, label: 'plugins.installationreceived.delivered' },
    { value: 2, label: 'plugins.installationreceived.not-delivered' },
    { value: 3, label: 'plugins.installationreceived.na' }
  ];

  public documentTypes: any = [];
  public statuses: any = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private receivedFactory: InstallationReceivedPluginFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, null);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  public updateReceivedValues(
    inspectionId: string,
    pointId: string,
    pluginId: string,
    receivedValues: any[]
  ): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, receivedValues).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  public getDocumentTypes() {
    return this.documentTypes;
  }

  public getStatuses() {
    return this.statuses;
  }

  public applyTranslations() {
    this.documentTypes = [];
    this.statuses = [];
    this.copyTranslationValues(this.documentTypeKeys, this.documentTypes, this.language);
    this.copyTranslationValues(this.statusKeys, this.statuses, this.language);
  }

  private update(inspectionId: string, pointId: string, pluginId: string, receivedValues: any[]): Observable<any> {
    return this.receivedFactory
      .updateReceivedValues(inspectionId, pointId, pluginId, receivedValues, 'ReceivedValues')
      .pipe(
        flatMap((plugin) => {
          if (this.isInspectionInOffline(inspectionId)) {
            return of(plugin);
          }
          return this.apiService.post(plugin.postServerUrl, plugin.config);
        })
      );
  }
}
